<template>
  <PageHeader title="Cart" />
  <v-container density="compact" dense="true" v-model="checkoutStage">
    <CheckoutProgress :checkout-stage="checkoutStage" />
    <div class="d-flex">
      <v-card class="pa-2a ma-2 w-100" :value="1">
        <v-card-text><MemberOrderCart /></v-card-text>
        <v-card-actions>
          <v-spacer />
          <RouterLink to="/checkout">
            <v-btn
              variant="flat"
              color="primary"
              :disabled="!session?.ready.value || !session.isOpen.value"
              :loading="session?.busy.value"
              >Continue to Checkout</v-btn
            >
          </RouterLink>
        </v-card-actions>
      </v-card>
    </div>
  </v-container>
</template>

<script lang="ts" setup>
import {
  memberOrderSessionKey,
  type MemberOrderSession,
} from "@/composables/shop/useMemberOrder";
const session = inject<MemberOrderSession | null>(memberOrderSessionKey, null);
const checkoutStage = ref(1);
</script>
